import axios from "axios";
import Config from "../../config";

const actionBuscarChatsParaVincular = (clienteId, search) => {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chamados/${clienteId}/buscar-chats${params}`,
    });
};

export default actionBuscarChatsParaVincular;
